import { StackLayout } from "../layouts";
import { rows, HeroBanner, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import App from "../controllers/App/App";
import { parseSort } from "colbi_web_ui/lib/utils/queryUtils";
import AuditToolbar from "../components/AuditToolbar/AuditToolbar";
import { DownloadButton } from "../components/DownloadButton/DownloadButton";
import { getConfigVariable } from "../config/config";

const queries = (args = {}) => {
    const entityResource = args.entity === "nc_audit" ? "nc_rules_summary" : `${args.entity}`;
    let test = [
        {
            resource: "nc_audit_summary",
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                importId: args.importId,
            },
            body: "severity, count",
        },
        {
            resource: "nc_finding_entities",
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                modulePrefix: args.modulePrefix,
                importId: args.importId,
            },
            body: `entity, count, model`,
        },
        {
            resource: entityResource,
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                importId: args.importId,
                locale: args.locale,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                sort: args.sort ? { type: "[SortInput!]", value: parseSort(args.sort) } : undefined,
                page: parseInt(args.page || 0),
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
            },
            body: `__typename, hasMore, total, items{...nc_rules_summary}, filters(projectId:$projectId, fiscalYear:$fiscalYear, importId:$importId){ prop, name, type, list, disableOperators, mandatory }`,
            downloadable: false,
            xlsxTranslation: entityResource,
            //We had to do two minor changes to the way we did pagination.
            //The following variable allows that in fetchAction.js
            isDatagridReq: true,
        },
        {
            resource: `nc_audit_export`,
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                importId: args.importId,
                locale: args.locale,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
            },
            body: `report`,
            downloadable: true,
            downloadOnly: true,
            xlsxTranslation: "nc_audit_export",
        },
    ];
    return test;
};

const auditByFile = (path, navigation, exact, title, navByImportId = false) => ({
    path,
    navigation,
    component: App,
    queries,
    exact,
    navByImportId,
    title,
    headerComponentConfigs: {
        label: "Download",
        type: "single",
    },
    headerComponents: [{ component: DownloadButton }],
    components: [
        {
            component: HeroBanner,
            modifiers: ["--root-margin-bottom-normal"],
            props: {
                title: "label(Audit Results)",
                summary: "query(0).list",
                overviewSummaryWidget: true,
            },
        },
    ],
    routes: [
        {
            path,
            exact: true,
            queries,
            component: StackLayout,
            components: [
                {
                    component: DataGrid,
                    modifiers: ["--root-margin-top-negative", "--row-style-alternate"],
                    props: {
                        id: "results",
                        items: "query(2).list",
                        filter: "param(filter)",
                        availableFilters: "query(2).filters",
                        card: rows.CellCard,
                        metadata: "query(2).metadata",
                        page: "param(page)",
                        status: "status(2)",
                        pageSize: "param(pageSize)",
                        sort: "param(sort)",
                        pageDefault: 10,
                        header: "query(2).header",
                        details: "param(entity)",
                        toolbar: AuditToolbar,
                        toolbarProps: {
                            tabsProps: {
                                basePath: `${path}`,
                                showCount: true,
                                data: "query(1).list",
                                labelKey: "entity",
                                routeKey: "model",
                                preserveEmptyTabs: true,
                                preserveFilters: ["ID"],
                                // concatTab: true,
                                redirectEnabler: true,
                                stickyTop: 0,
                            },
                        },
                    },
                },
            ],
        },
    ],
});

export default auditByFile;
